<template>
  <div class="end-time">
    {{ scope.row.isForever ? '不限' : (scope.row.isEnd ? '已结束' : scope.row.endTime.split(' ')[0]) }}
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
